import { render, staticRenderFns } from "./TraineeSponsorJoboffers.vue?vue&type=template&id=6dc468c4&"
import script from "./TraineeSponsorJoboffers.vue?vue&type=script&lang=js&"
export * from "./TraineeSponsorJoboffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports